import { featureFlags } from "@app/environments/environment";

const STORAGE_KEY = "featureFlags";
const STORAGE_KEY_GROUP = "featureFlagsGroup";

const initialFeatureFlagsSnapshot: Record<string, boolean> = JSON.parse(
    JSON.stringify(featureFlags)
);

const stored = loadFromLocalStorage();
Object.keys(featureFlags).forEach((key) => {
    if (Object.prototype.hasOwnProperty.call(stored, key)) {
        featureFlags[key as keyof typeof featureFlags] = stored[key];
    }
});

const runtimeFeatureFlags = featureFlags;

function isFlagAvailable(key: string): boolean {
    return Object.prototype.hasOwnProperty.call(
        featureFlags,
        key
    );
}

function loadFromLocalStorage(): Record<string, boolean> {
    const raw = localStorage.getItem(STORAGE_KEY);
    try {
        return raw ? JSON.parse(raw) : {};
    } catch {
        return {};
    }
}

function saveToLocalStorage(flags: Record<string, boolean>) {
    const clean: Record<string, boolean> = {};
    for (const key in initialFeatureFlagsSnapshot) {
        clean[key] = flags[key];
    }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(clean));
}

function clearFeatureFlagsFromStorage() {
    localStorage.removeItem(STORAGE_KEY);
}

function saveSelectedFlagCategory(group: 'grouped' | 'all') {
    localStorage.setItem(STORAGE_KEY_GROUP, group);
}

function loadSelectedFlagCategory(): string {
    const raw = localStorage.getItem(STORAGE_KEY_GROUP);
    try {
        return raw ?? 'grouped';
    } catch {
        return 'grouped';
    }
}

export const FeatureFlagStore = {
    runtimeFeatureFlags,
    initialFeatureFlagsSnapshot,
    saveToLocalStorage,
    clearFeatureFlagsFromStorage,
    loadSelectedFlagCategory,
    saveSelectedFlagCategory,
    isFlagAvailable
};